module.exports = {
    // deprecatred see MyWorkType
    type: {
        TASK: 1,
        EVENT: 2,
        MOM: 3,
        REPORT: 4,
        REMINDER: 6,
        RATE_EXPERIENCE: 8,
        TASK_ASSIGNED: 9,        // experimental
        TODO: 10
    },

    group: {
        INBOX: "inbox",
        TODAY: "today",
        SOMEDAY: "someday",
        PASTDUE: "pastdue",
        DAY: "day-",
    },

    // see enum MyTasksView
    viewType: {
        // SCHEDULE: "schedule",
        // PROJECT: "project",
        // FROM_USER: "fromUser",
        ACTION_REQUIRED: "action-required",
        ASSIGNED_TO_ME: "assigned-to-me",
        ALL_INVOLVED: "all-involved",
        CREATED_BY_ME: "created-by-me",
        SOMEDAY: "someday",
        PASTDUE: "pastdue",

        WEEK: "week",
        TODAY: 'today',
        SPLIT: 'split',
    },

    resourceType: {
        ACTION_REQUIRED_TASK: "action-required-task",
        ASSIGNED_TO_TASK    : "assigned-to-task",
        DEADLINE            : "deadline",

        MILESTONE           : "milestone",
        PERSONAL_EVENT      : "personal-event",
        COMPANY_EVENT       : "company-event",

        MEETING             : "meeting",
        REMINDER            : "reminder",
        REPORT              : "report",       // used only to filter resources
        MENTION             : "mention",      // used only to filter resources

        task                : ["action-required-task", "assigned-to-task", "deadline"],
        event               : ["milestone", "personal-event", "company-event"],
        other               : ["meeting", "reminder", "report", "mention"]
    },

    resourcePrefixSeparator: "__",

    resourceIdPrefix: {
        "action-required-task":   "ar",
        "assigned-to-task":       "as",
        "deadline":               "de",

        "milestone":              "mls",
        "personal-event":         "pe",

        "meeting":                "mtn",
        "reminder":               "rmn",
        "report":                 "rpt",
        "mention":                "men",
    },
};
